import Fuse from "fuse.js";
import { ISearchResult, SearchAdapter, SearchItem } from "../types/search-engine.types";

export class FuseAdapter implements SearchAdapter {
    private fuse!: Fuse<SearchItem>;

    index(items: SearchItem[]) {
        this.fuse = new Fuse(items, {
            keys: [
                {name: "title", weight: 0.6},
                {name: "description", weight: 0.3},
                {name: "tags", weight: 0.1}
            ],
            threshold: 0.3,          // stricter (lower = better precision)
            distance: 100,            // limit how far match can be
            minMatchCharLength: 2,    // ignore 1-letter noise
            ignoreLocation: false     // consider word position
        });
    }


    search(query: string, quickLinks: SearchItem[]): ISearchResult {
        if (!query) {
            return {
                results: [],
                quickLinks
            };
        }

        const fuseResults = this.fuse.search(query).map(r => r.item);
        const resultIds = new Set(fuseResults.map(r => r.id));

        const matchedQuickLinks = quickLinks.filter(q => !resultIds.has(q.id));


        return {
            results: fuseResults,
            quickLinks: matchedQuickLinks.length > 0
                ? matchedQuickLinks
                : quickLinks
        };
    }
}
